import * as NProgress from 'nprogress';
import { message } from 'ant-design-vue';
import { LOGIN_NAME, whiteNameList } from './constant';
import { generatorDynamicRouter } from './generatorRouter';
import { getMenuForCurrentUser } from '@/api/user';
import basicStorage from '@/utils/basicStorage';
import { userStore } from '@/store/user';
import { TOKEN } from '@/utils/request';
import { getCrypto } from '@/utils/cryptoConfig';
import { resetRealtimeSession } from '@/utils/useWsClient';
import { rotateAuthSessionEpoch } from '@/utils/authSession';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: true });

export function createRouterGuards(router) {
  router.beforeEach(async (to, _, next) => {
    NProgress.start();
    // token是否在有效时间内
    let token = basicStorage.getItem(TOKEN);
    if (to.query.token) {
      const incomingToken = String(
        Array.isArray(to.query.token) ? to.query.token[0] : to.query.token
      );
      if (token && incomingToken !== token) {
        const resetPromise = resetRealtimeSession();
        basicStorage.removeItem(TOKEN);
        await resetPromise;
        rotateAuthSessionEpoch();
        userStore().reset();
        basicStorage.setItem(TOKEN, incomingToken);
        const nextQuery = { ...to.query };
        delete nextQuery.token;
        window.location.replace(
          router.resolve({ path: to.path, query: nextQuery, hash: to.hash }).href
        );
        return;
      }
      if (!token) rotateAuthSessionEpoch();
      token = incomingToken;
      basicStorage.setItem(TOKEN, token);
    }
    if (token) {
      if (to.path === '/') {
        next('/layout/welcome');
        return;
      }
      const store = userStore();
      const storeMenu = store.menus;

      if (!storeMenu || !store.menus?.length) {
        try {
          // store.load();
          const apiRouter = await getMenuForCurrentUser();
          getCrypto();
          if (apiRouter?.content) {
            const routerData = apiRouter.content?.filter(
              v => v.state === 'VALID' && v.type === 'BACK'
            );
            // getBtnPower方法 整理按钮权限
            getBtnPower(apiRouter.content, store);
            const generatorResult = await generatorDynamicRouter([...routerData]);
            store.menus = generatorResult.menus;
            store.persist();
            const hasRoute = router.hasRoute(to.name);
            if (!hasRoute) {
              // 如果该路由不存在，可能是动态注册的路由，它还没准备好，需要再重定向一次到该路由
              next({ ...to, replace: true });
            } else {
              next();
            }
          } else {
            message.warning('您的帐号没有配置菜单权限，请联系管理员。', 5);
          }
        } catch (error) {
          console.log(error);
          store.menus = [];
          const hasRoute = router.hasRoute(to.name);
          if (!hasRoute) {
            next({ ...to, replace: true });
          } else {
            next();
          }
        }
      } else {
        next();
      }
    } else {
      await resetRealtimeSession();
      if (whiteNameList.some(n => n === to.name)) {
        // 在免登录名单，直接进入
        next();
      } else {
        if (basicStorage.getItem('token-time')) {
          basicStorage.removeItem('token');
        }
        next({ name: LOGIN_NAME, query: { redirect: to.fullPath }, replace: true });
      }
    }
  });
  router.afterEach(() => {
    NProgress.done();
  });

  router.onError(error => {
    console.log('路由错误:', error);
  });
}
const getBtnPower = (data, store) => {
  const btnData = data.filter(v => v.menuType === 'PAGE');
  const btnPower = [];
  btnData.forEach(v => {
    btnPower.push(v.perms);
  });
  store.btnPower = btnPower;
};
